import { type ValidationRule } from '../../types';
import { checkCameraEquipmentReference } from '../../util/cameraEquipment';
import { ActionRequiredError } from '../../util/errors';

import { CanonicalStepRuleBase } from './base';
import type { CanonicalValidateArgs } from './base';

class ClassifyRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.Classify', 'Classify');
  }

  protected validate({ args, ctx }: CanonicalValidateArgs): void {
    checkCameraEquipmentReference(
      ctx,
      (args as { cameraEquipmentId?: string | null }).cameraEquipmentId,
      'cameraEquipmentId',
    );

    this.checkFallback(args);
  }

  /**
   * Check if the fallback value is configured.
   * @param args - The arguments of the step.
   */
  private checkFallback(args: any): void {
    if (!args.fallbackValue) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'Fallback value is not configured',
        fieldId: 'fallbackValue',
      });
    }
  }
}

export const ClassifyValidation: ValidationRule =
  new ClassifyRule().toValidationRule();
